import reducer from './reducer'

import * as loansOperations from './operations'
import * as loansSelectors from './selectors'

export { loansOperations, loansSelectors }

export default reducer
